import {
  DatePicker,
  Divider,
  Form, 
  InputNumber,
  Radio,
  Select,
  Space, 
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux"; 
import { useWatch } from "antd/es/form/Form";

function Operations({ form }) {
  const urlAgency = "api/v2/agency/get";
  const urlFundingSrc = "sch/get_funding_source";
  const { loading, data, dataFundingSrc, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[urlAgency] || [],
    dataFundingSrc: state.fetch.data[urlFundingSrc] || [],
  }));
  const { activeObjSchemes, wtrFunding } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["communitySchemes"],
    wtrFunding: state.fetch.wtrFunding,
  }));
  const plainOptions = ["Yes", "No"];

  const [fundings, setFundings] = useState([]);

  const [inputFundingValue, setInputFundingValue] = useState("");

  const handleAddFunding = () => {
    if (inputFundingValue.trim() && !fundings?.includes(inputFundingValue)) {
      const newFundings = [...fundings, inputFundingValue];
      setFundings(newFundings);
      setInputFundingValue("");
      form.setFieldsValue({ schFundSource: newFundings });
    }
  };

  const handleRemoveFunding = (funding) => {
    const newFundings = fundings?.filter((b) => b !== funding);
    setFundings(newFundings);
    form.setFieldsValue({ schFundSource: newFundings });
  };

  const operMainYes = useWatch("schHasOperationalMaintenance", form);

  useEffect(() => {
    if (form.getFieldValue("schHasOperationalMaintenance") === "No") {
      form.setFieldsValue({ schOperationalMaintenance: null });
    }
  }, [form, form.getFieldValue("schHasOperationalMaintenance")]);

 
  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
      <Form.Item
        name="schAgencyId"
        className=""
        label={"Implementor"}
        rules={[
          {
            required: true,
            message: "Please add Implementor",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            data?.length > 0 &&
            data?.map((item) => ({
              value: item?.agencyId,
              label: item?.agencyName,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>
      <Form.Item
        label="Construction Start Date"
        name="schConstructionStartDate"
        rules={[
          {
            required: true,
            message: "construction start date is required",
          },
        ]}
      >
        <DatePicker format={"YYYY MMM DD"} className="input" />
      </Form.Item>
      <Form.Item
        label="Construction End Date"
        name="schConstructionEndDate"
        rules={[
          {
            required: true,
            message: "construction end date is required",
          },
        ]}
      >
        <DatePicker format={"YYYY MMM DD"} className="input" />
      </Form.Item>
      <Form.Item
        label="Revised End Date"
        name="schRevisedEndDate"
        rules={[
          {
            required: false,
            message: "Revised end date is required",
          },
        ]}
      >
        <DatePicker format={"YYYY MMM DD"} className="input" />
      </Form.Item>
      <Form.Item
        label="Source of Funding"
        name="schFsId"
        rules={[{ required: false, message: "Source of Funding is required" }]}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              <Space style={{ padding: "8px 8px 4px" }}>
                <span className="select-info mt-1">
                  Choose one or more of the following sources
                </span>
              </Space>
              <Divider style={{ margin: "8px 0" }} />
              {menu}
            </>
          )}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children?.toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          tagRender={(props) => {
            const { label, closable, onClose } = props;
            return (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "4px 8px",
                  margin: "2px",
                  borderRadius: "4px",
                  background: "#f5f5f5",
                }}
              >
                {label}
                {closable && (
                  <span
                    onClick={onClose}
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer",
                      color: "red",
                    }}
                  >
                    ×
                  </span>
                )}
              </span>
            );
          }}
          dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
        >
          {dataFundingSrc?.map((item) => (
            <Select.Option key={item?.fsId} value={item?.fsId}>
              {item?.fsType}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      {/* <Form.Item
        name="schFundSource"
        label={"Source of Funding"}
        rules={[
          {
            required: true,
            message: "Please add source of funding",
          },
        ]}
      >
        <div className="flex w-full gap-x-[1rem]">
          <Input
            className="input"
            value={inputFundingValue}
            onChange={(e) => setInputFundingValue(e.target.value)}
            placeholder="Type and click + to add"
            onPressEnter={handleAddFunding}
          />
          <button
            type="button"
            onClick={handleAddFunding}
            className="cstm-btn !border-none !w-[50px] !bg-white !text-darkBlue"
          >
            Add <img src={svg40} alt="svg40" />
          </button>
        </div>

        <div className="mt-[.31rem]">
          {fundings?.map((funding) => (
            <Tag
              className="rounded-[.25rem] bg-[#F1F3F5] px-[.3125rem] py-[.25rem] gap-[.25rem]"
              key={funding}
              closable
              onClose={() => handleRemoveFunding(funding)}
            >
              {funding}
            </Tag>
          ))}
        </div>
      </Form.Item> */}
      <Form.Item
        name="schFmId"
        className=""
        label={"Mode of Funding"}
        rules={[
          {
            required: true,
            message: "Please select mode of funding",
          },
        ]}
      >
        <Select
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={
            wtrFunding?.length > 0 &&
            wtrFunding?.map((item) => ({
              value: item?.fmId,
              label: item?.fmType,
            }))
          }
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
      </Form.Item>
      <Form.Item
        name="schInitialExpenditure"
        label={"Cost of Establishment"}
        rules={[
          {
            required: true,
            message: "Please add cost of establishment",
          },
        ]}
      >
        <InputNumber
          suffix="Kes."
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schActualExpenditure"
        label={"Actual Expenditure To Date"}
        rules={[
          {
            required: true,
            message: "Please add actual Expenditure to date",
          },
        ]}
      >
        <InputNumber
          suffix="Kes."
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>
       
      <Form.Item
        name="schHasOperationalMaintenance"
        className=""
        label={"Do you carry out operation and maintenance ?"}
        rules={[
          {
            required: true,
            message: "Please select operation and maintenance",
          },
        ]}
      >
        <Radio.Group options={plainOptions} />
      </Form.Item>
      {operMainYes === "Yes" ? (
        <Form.Item
          name="schOperationalMaintenance"
          label={"Cost of O&M per month"}
          rules={[
            {
              required: true,
              message: "Please add cost of O&M per month",
            },
          ]}
        >
          <InputNumber
            suffix="Kes."
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            className="input flex"
          />
        </Form.Item>
      ) : null}
    </div>
  );
}

export default Operations;
